import { render, staticRenderFns } from "./BestIn.vue?vue&type=template&id=7d768c76&scoped=true"
import script from "./BestIn.vue?vue&type=script&lang=js"
export * from "./BestIn.vue?vue&type=script&lang=js"
import style0 from "./BestIn.vue?vue&type=style&index=0&id=7d768c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d768c76",
  null
  
)

export default component.exports